var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('iv-cell-action-base',_vm._b({class:{ 'is-disabled': _vm.isDisabled },attrs:{"icon":"fa-file-download","label":_vm.defaultLabel,"visible":_vm.isVisible},on:{"click":_vm.handleClick}},'iv-cell-action-base',{ ..._vm.$attrs, ..._vm.$props },false))
}
var staticRenderFns = []

export { render, staticRenderFns }